import type { DebugMetadata, DebugSnapshot } from './debug/types';

export const LIMITS = {
	sourceBytes: 128 * 1024,
	inputBytes: 64 * 1024,
	outputBytes: 256 * 1024,
	memoryBytes: 64 * 1024 * 1024,
	compileMs: 120_000,
	runMs: 5_000,
	memoryPageBytes: 256,
} as const;

export interface CompileRequest {
	type: 'compile';
	source: string;
	debug?: boolean;
}
export type CompileEvent =
	| { type: 'status'; message: string }
	| {
			type: 'compiled';
			module: WebAssembly.Module | null;
			diagnostics: string;
			debug?: DebugMetadata;
	  }
	| { type: 'error'; message: string };

export interface MemoryPage {
	offset: number;
	bytes: Uint8Array;
	totalBytes: number;
}

export type RunStatus = 'exited' | 'trapped' | 'timeout' | 'stopped' | 'output-limit';
export interface RunResult {
	status: RunStatus;
	stdout: string;
	stderr: string;
	exitCode: number | null;
	durationMs: number;
	error?: string;
	memoryBytes: number;
}

export type RunRequest =
	| {
			type: 'run';
			module: WebAssembly.Module;
			stdin: string;
			debug?: { metadata: DebugMetadata; control: SharedArrayBuffer };
	  }
	| { type: 'memory'; offset: number; requestId: number };
export type RunEvent =
	| { type: 'paused'; snapshot: DebugSnapshot; memory: MemoryPage; stdout: string; stderr: string }
	| { type: 'output'; stdout: string; stderr: string }
	| { type: 'finished'; result: RunResult; memory: MemoryPage | null }
	| { type: 'memory'; requestId: number; memory: MemoryPage };

export interface TestCase {
	id: string;
	name: string;
	stdin: string;
	expectedStdout: string;
	expectedExitCode: number;
	timeoutMs: number;
	normalizeWhitespace: boolean;
}
export interface TestResult {
	testId: string;
	passed: boolean;
	run: RunResult;
	outputMatches: boolean;
	exitMatches: boolean;
}

export function errorMessage(error: unknown): string {
	return error instanceof Error ? error.message : String(error);
}
